import React, { useState, useRef } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';
import SuccessPopup from '../../components/SuccessPopup/SuccessPopup';
import './SignupPage.css';

function SignupPage() {
  const navigate = useNavigate();
  const cardRef = useRef(null);
  const [formData, setFormData] = useState({
    name: '',
    username: '',
    password: '',
    email: '',
    mobile: ''
  });
  const [showSuccess, setShowSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Replace this URL with your deployed Google Apps Script Web App URL
  const GOOGLE_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbwHlenQO83gnUr8SuxjXDqtaLcQ-ofmRM6YUtqqMXqIxRDFts6HMjzTYzD2dafoA7r4kA/exec";

  const handleClose = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  const handleOverlayClick = (e) => {
    if (cardRef.current && !cardRef.current.contains(e.target)) {
      handleClose();
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    try {

    if (!/^\d{10}$/.test(formData.mobile)) {
      toast.error("Mobile number must be exactly 10 digits");
      return;
    }

    if (formData.password.length < 6) {
      toast.error("Password must be at least 6 characters long");
      return;
    }

    // Fetch existing users from localStorage
    const existingUsers = JSON.parse(localStorage.getItem('users')) || [];

    // Check if username already exists
    const duplicateUsername = existingUsers.some(
      (user) => user.username === formData.username
    );

    if (duplicateUsername) {
      toast.error("Username already taken. Please choose a different one.");
      return;
    }

    // Check if email already exists
    const duplicateEmail = existingUsers.some(
      (user) => user.email === formData.email
    );

    if (duplicateEmail) {
      toast.error("Email already registered. Please log in instead.");
      return;
    }

    // Add new user to the mock database
    const newUser = { ...formData };
    existingUsers.push(newUser);
    localStorage.setItem('users', JSON.stringify(existingUsers));

    setIsLoading(true);

    // Append to Google Sheet only if a valid Web App URL is provided
    if (GOOGLE_SCRIPT_URL) {
      fetch(GOOGLE_SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: formData.name,
          username: formData.username,
          email: formData.email,
          mobile: formData.mobile,
          date_time: new Date().toLocaleString()
        })
      })
        .then(() => {
          setIsLoading(false);
          setShowSuccess(true);
        })
        .catch((error) => {
          toast.error("Error saving to Google Sheets: " + error.message);
          setIsLoading(false);
          // Show success popup anyway since local storage worked
          setShowSuccess(true);
        });
    } else {
      setIsLoading(false);
      setShowSuccess(true);
    }
    } catch (error) {
      toast.error("An error occurred during signup: " + error.message);
      setIsLoading(false);
    }
  };

  const handleSuccessClose = () => {
    setShowSuccess(false);
    navigate(-1);
  };

  return (
    <>
      <div className='SignupPage_ctn' onClick={handleOverlayClick}>
        <div className='SignupPage_card' ref={cardRef}>
          <button 
            type="button" 
            className="SignupPage_close_btn" 
            onClick={handleClose} 
            aria-label="Close"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          <div className='SignupPage_heading'>Sign Up</div>
          <form className='SignupPage_form' onSubmit={handleSubmit}>
            <input type="text" name="name" placeholder='Name' value={formData.name} onChange={handleChange} required />
            <input type="text" name="username" placeholder='Username' value={formData.username} onChange={handleChange} required />
            <input type="email" name="email" placeholder='Email ID' value={formData.email} onChange={handleChange} required />
            <input type="tel" name="mobile" placeholder='Mobile Number' maxLength={10} value={formData.mobile} onChange={handleChange} required />
            <input type="password" name="password" placeholder='Password' value={formData.password} onChange={handleChange} required />
            <button type="submit" disabled={isLoading}>
              {isLoading ? 'Signing Up...' : 'Sign Up'}
            </button>
          </form>
        </div>
      </div>
      {showSuccess && (
        <SuccessPopup
          message="Your account has been successfully created."
          onClose={handleSuccessClose}
        />
      )}
    </>
  );
}

export default SignupPage;
